import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom'
import Home from './components/home'
import Menu from './components/menu'
import Administration from './components/Administration'

const defaultRoute = () => (
  <Router>
    <div className='full-height'>
      <Menu />

      <Route exact path="/" component={Home}/>
      <Route path="/administration" component={Administration}/>
    </div>
  </Router>
)

export default defaultRoute




// WEBPACK FOOTER //
// ./src/router.js